const PSEvents = require('PSEvents');
cc.Class({
    extends: cc.Component,

    properties: {
        prefix: {
            default: '',
            notify: function() { this._updateValue(); }
        },
        suffix: {
            default: 'x',
            notify: function() { this._updateValue(); }
        },
        maxExposure: {
            default: 0,
            notify: function() { this._updateValue(); }
        },
        maxExposureLabel: cc.Label
    },

    onLoad () {
        if (!this.maxExposureLabel) {
            this.maxExposureLabel = this.node.getComponent(cc.Label);
        }
        if (!this.maxExposureLabel) {
            this.maxExposureLabel = this.node.getComponentInChildren(cc.Label);
        }
        if (!this.maxExposureLabel) {
            console.warn('MaxExposure label is not defined');
        }
        PSEvents.onEngineInitialized(() => {
            if (window.PSGames.launchParams && window.PSGames.launchParams.maxExposure) {
                this.maxExposure = window.PSGames.launchParams.maxExposure;
            }
        });
    },

    _updateValue () {
        if (this.maxExposureLabel) {
            this.maxExposureLabel.string = this.prefix + this.maxExposure + this.suffix;
        }
    },

});
